<template src="./vehiclechecks.html"></template>
<script>
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import Axios from "axios";
import $ from "jquery";
var moment = require("moment");

export default {
  components: {
    VueGallery,
    Multiselect,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      basic: {
        currentPage: 1,
        totalPages: 0,
        type: "",
      },

      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      ShowDownloadLoader: false,
      SearchKey: "",
      fromDate: "",
      toDate: "",
      vrm: "",
      driver: "",
      branch: "",
      vehicle_group: "",
      CompanyChecksSelected: [],
      StatusSelected: [],
      branchModuleEnable: false,

      VehicleChecks: [],
      CompanyChecks: [],
      Status: ["Pass", "Warning", "Fail"],
      VehicleNotes: "",
      ShowVehicleCheckImageModel: false,
      ShowVehicleNotesModel: false,
      ShowVehicleNotesModelHeading: "Notes",
      excel_data: [],
      lightgallery: [],
      biglightgallery: [],
      gindex: 1,
      galleryoptions: {
        prevClass: "prev",
        nextClass: "next",
      },
      vehicle_class: 0,
      VehicleClass: "",
      FleetSubscription: [],
      ActivityPage: 1,
      LastPageRequest: 0,
      Branches: {},
      Groups:{},
      VehicleCheckDuration:false

    };
  },
  watch: {
    "$route.query": {
      handler: function () {
        this.vehicle_class = this.$route.params.VehicleClassID;
        this.ActivityPage = 1;
        this.LastPageRequest = 0;
        this.basic.currentPage = 1;
        this.fromDate = "";
        this.toDate = "";
        this.VehicleChecks = [];
        this.GetVehicleChecksList();
      },
      deep: true,
    },
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if (FleetSubscriptionModules["Branches"]) {
      this.branchModuleEnable = true;
    }

    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions["Vehicle Checks"] ||
        !AccountPermissions["Vehicle Checks"]["enable"])
    ) {
      this.$router.push("/");
    }

    document.title = pbx_SiteTitle + " - Vehicles Checks";
    this.vehicle_class = this.$route.params.VehicleClassID;
    this.ActivityPage = 1;
    this.LastPageRequest = 0;
    this.VehicleChecks = [];
    this.GetVehicleChecksList();
    this.GetGroups();    
    this.GetBranches();

    var CompanySettingsKey = JSON.parse(localStorage.getItem("Company") );
    if(CompanySettingsKey.fleet_settings_key != "undefined"){
      CompanySettingsKey = JSON.parse(CompanySettingsKey.fleet_settings_key);
      if (CompanySettingsKey != null && typeof CompanySettingsKey.VehicleCheckDuration != "undefined" && CompanySettingsKey.VehicleCheckDuration) {
        this.VehicleCheckDuration = CompanySettingsKey.VehicleCheckDuration;
      }
    }   
     
  },

  methods: {
    GetGroups() {
      var obj = {
        token: localStorage.getItem("token"),
      };
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.Groups = Response.data.records;
        }
      });
    },
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    SearchVehicleChecks(type) {
      this.ActivityPage = 1;
      this.LastPageRequest = 0;
      this.VehicleChecks = [];
      this.GetVehicleChecksList(type);
    },
    GetVehicleChecksList(type = "") {
      if ((this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) || type == "download") {
        this.LastPageRequest = this.ActivityPage;
        var obj = {
          token: localStorage.getItem("token"),
          paginate: true,
          page: this.ActivityPage,
        };
        if (type == "search" || type == "download") {
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
          obj.driver = this.driver;
          obj.branch_id = this.branch;
          obj.vehicle_group = this.vehicle_group;
          obj.companychecksselected = this.CompanyChecksSelected;
          obj.statusselected = this.StatusSelected;
        }
        if (type == "download") {
          delete obj.paginate;
          delete obj.page;
          obj.download = true;          
          this.ShowDownloadLoader = true;
        } else {
          this.ShowLoader = true;
        }
        obj.vehicle_class = this.vehicle_class;

        Axios.post(Endpoints.VehicleChecks.VehicleChecksList, obj).then((Response) => {
            if (Response?.data?.success) {
              this.ShowLoader = false;
              this.ShowDownloadLoader = false;
              if (type == "download") {
                this.SetVehicleChecksExcelData(Response.data.FleetCheckSubmit);
              } else {
                if (this.ActivityPage == 1) {
                  this.basic.totalPages = Response.data.totalPage;
                  this.basic.type = type;
                }
                this.VehicleChecks = Response.data.FleetCheckSubmit;
                this.CompanyChecks = Response.data.CompanyChecks;
                this.VehicleClass = Response.data.VehicleClass.title;
                this.VehicleChecks.forEach((vehicleCheck,index) => {
                	vehicleCheck.value.forEach((checkValue,index2) => {  
                		if(checkValue.photo){   
                			this.VehicleChecks[index]['value'][index2]['photo'] = JSON.parse(checkValue.photo);
                		}
                			           		                   	
                    	if(checkValue.value==0 && checkValue.warning!=1){		                        
	                        this.VehicleChecks[index]['value'][index2]['variant']='secondary';
                        	this.VehicleChecks[index]['value'][index2]['text']='N/A';
	                    }	                    
	                    if(checkValue.value==1 && checkValue.warning!=1){
	                    	this.VehicleChecks[index]['value'][index2]['variant']='success';
                        	this.VehicleChecks[index]['value'][index2]['text']='Pass';
	                    }	                    
	                    if(checkValue.value<=1 && checkValue.warning==1){
	                    	this.VehicleChecks[index]['value'][index2]['variant']='warning';
                        	this.VehicleChecks[index]['value'][index2]['text']='Warning';		
	                    }	                    
	                    if(checkValue.value==2){
	                        this.VehicleChecks[index]['value'][index2]['variant']='danger';
                        	this.VehicleChecks[index]['value'][index2]['text']='Fail';
	                    }
                	})
                })                
              }
            }
          }
        );
      }
    },
    
    SetVehicleChecksExcelData(VehicleChecks) {
      this.excel_data = [];
      VehicleChecks.forEach((element) => {
        var obj = {};
        obj["created_at"] = element.created_at;
        obj["vrm"] = element.vehicle && element.vehicle.vrm;
        //obj["driver"] = element.driver.forename + " " + element.driver.surname;
        obj["driver"] = element.driver && element.driver.name;
        this.CompanyChecks.forEach((CompanyElement) => {
          obj[CompanyElement.name] = "";
          element.value.forEach((ValueElement) => {
            if (ValueElement.company_check_id == CompanyElement.id) {
              if (ValueElement.value == 0 && ValueElement.warning != 1) {
                obj[CompanyElement.name] = "N/A";
              }else if (ValueElement.value == 1 && ValueElement.warning != 1) {
                obj[CompanyElement.name] = "Pass";
              }else if (ValueElement.value <= 1 && ValueElement.warning == 1) {
                obj[CompanyElement.name] = "Warning";
              }
              if (ValueElement.value == 2) {
                obj[CompanyElement.name] = "Fail";
              }
            }
          });
        });

        if (element.safe == 1) obj["safe"] = "Safe";
        else obj["safe"] = "UnSafe";

        obj["current_mileage"] = element.current_mileage;
        obj["notes"] = element.notes;
        
        this.excel_data.push(obj);
      });

      setTimeout(function () {
        document.getElementById("downloadexcel").click();
      }, 1000);
    },
    ShowVehicleNotes(VehicleCheck, type = "notes") {
      if (VehicleCheck.notes != null && VehicleCheck.notes != "") {
        this.ShowVehicleNotesModel = true;
        this.VehicleNotes = VehicleCheck.notes;
        this.ShowVehicleNotesModelHeading = "Notes";
      }
      /*if(VehicleCheck.notes!=null && VehicleCheck.notes!='' && type=='notes'){
  		this.VehicleNotes = VehicleCheck.notes;
  		this.ShowVehicleNotesModel = true;
  		this.ShowVehicleNotesModelHeading='Notes';
  	}
  	if(VehicleCheck.warning!=null && VehicleCheck.warning!='' && type=='warning'){
  		//this.VehicleNotes = VehicleCheck.warning;
  		this.VehicleNotes = VehicleCheck.notes;
  		this.ShowVehicleNotesModel = true;
  		this.ShowVehicleNotesModelHeading='Warning';
  	}*/
    },
    ShowVehicleImage(VehicleCheck) {
      //console.log(VehicleCheck)	
      this.ShowVehicleCheckImageModel = true;
      this.lightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
      this.biglightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
      for (var i = 0; i < this.biglightgallery.length; i++) {
        this.biglightgallery[i] = this.ImageEndpoint + this.biglightgallery[i];
      }      
    },
    pagechanged() {
      if (
        this.ActivityPage > 0 &&
        this.LastPageRequest != this.basic.currentPage
      ) {
        this.ActivityPage = this.basic.currentPage;
        this.GetVehicleChecksList(this.basic.type);
      }
    },
  },
};
</script>
<style scoped>
.vehiclechecklist th:first-child,
.vehiclechecklist th:nth-child(2) {
  background: #fff !important;
}
.vehiclechecklist th:first-child {
  min-width: 119px;
}
.vehiclechecklist th:first-child,
.vehiclechecklist td:first-child,
.vehiclechecklist th:nth-child(2),
.vehiclechecklist td:nth-child(2),
.vehiclechecklist th:nth-child(3),
.vehiclechecklist td:nth-child(3) {
  position: sticky;
  left: -1px;
  background: #fff !important;
  z-index: 5;
}
.vehiclechecklist td:first-child,
.vehiclechecklist td:nth-child(2),
.vehiclechecklist td:nth-child(3) {
  position: sticky;
  left: -1px;
  background: #fff !important;
  z-index: 2;
}
.vehiclechecklist th:nth-child(2),
.vehiclechecklist td:nth-child(2) {
  left: 119px;
  min-width: 110px !important;
}
.vehiclechecklist th:nth-child(3),
.vehiclechecklist td:nth-child(3) {
  left: 229px;
  min-width: 150px !important;
}
.custom-scrollbar2 thead th {
  position: sticky;
  top: -1px;
  background: #fff;
  z-index: 4;
}
.datatable-vue table tbody tr:nth-child(odd) td {
  background-color: #f9f9f9 !important;
}
.datatable-vue table tbody tr:hover td {
  background-color: #f9f9f9 !important;
}
</style>
<style type="text/css">
td .text-primary {
  color: #8f4f88 !important;
}
.vehiclechecklist .btn {
  padding: 0.375rem 1.25rem;
}
.vehiclechecklist td.w120 {
  width: 120px !important;
  min-width: 120px !important;
}
.vehiclechecklist td.w100 {
  width: 100px !important;
  min-width: 100px !important;
}
.vehiclechecklist td.w80 {
  width: 80px !important;
  min-width: 80px !important;
}
span.failicon {
  position: relative;
}
td.CompanyChecks .fixedbage {
  position: absolute;
  z-index: 1;
}
td.CompanyChecks {
  position: relative;
}
td.CompanyChecks span.btn {
  padding: 3px 8px;
}
td.CompanyChecks .dropdown .dropdown-toggle {
  padding: 0.375rem 1.75rem;
}
td.CompanyChecks .dropdown {
  margin-bottom: 0px !important;
}
.nosubmenu .dropdown-toggle::after {
  display: none;
}
.dropdown-basic .dropdown .dropdown-menu {
  z-index: 99 !important;
}
.VehicleCheckPaging .page-item:last-child .page-link,
.VehicleCheckPaging .page-item:first-child .page-link {
  padding: 6px 6px 5px 6px;
}
.ChecksFilter .multiselect__content-wrapper {
  z-index: 1000;
}
@media screen and (max-width: 990px) {
  .search-data {
    width: 30%;
  }
  .d-flex.label-box {
    display: block !important;
    width: 100% !important;
  }

  .label-box span {
    width: 100% !important;
  }
  .searchregs {
    margin: 10px 0;
  }
}
@media screen and (max-width: 780px) {
  .search-data {
    width: 100%;
  }
}
@media (min-width: 762px) and (max-width: 1180px) {
  .vehicle-checks .col-xl-3,
  .vehicle-checks .col-xl-2 {
    max-width: 25%;
  }
  .vehicle-checks .col-xl-3 .searchregs {
    margin-top: 17px;
  }
  .search-data {
    margin-top: 17px;
    min-width: 100%;
  }
}
@media (min-width: 1180px) and (max-width: 1379px) {
  .vehicle-checks .col-xl-3,
  .vehicle-checks .col-xl-2 {
    max-width: 25%;
  }
  .vehicle-checks .col-xl-3 .searchregs {
    margin-top: 0;
  }
  .search-data {
    margin-top: 0;
    min-width: 100%;
  }
}
.textupper {
  text-transform: uppercase !important;
}
</style>
